<script setup lang="ts">
import { inject } from 'vue'
import type { LoadingStore } from './index'
const loadingStore = inject<LoadingStore>('loadingStore')
</script>

<template>
  <Transition name="fade">
    <div v-if="loadingStore?.show" class="loading-overlay">
      <div class="loading-container">
        <div class="spinner-box">
          <div class="spinner-ring"></div>
          <div class="spinner-core"></div>
        </div>
        <div class="loading-text-wrap">
          <span class="loading-text">LOADING</span>
          <div class="dots-pulse">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.1);
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.spinner-box {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #6366F1;
  border-left-color: #6366F1;
  animation: spin 1s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;
  filter: drop-shadow(0 0 8px rgba(99, 102, 241, 0.4));
}

.spinner-ring::after {
  content: '';
  position: absolute;
  inset: 8px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-bottom-color: #6366F1;
  border-right-color: #6366F1;
  opacity: 0.5;
  animation: spin 1.5s linear infinite reverse;
}

.spinner-core {
  width: 12px;
  height: 12px;
  background: #6366F1;
  border-radius: 50%;
  box-shadow: 0 0 20px #6366F1;
  animation: pulse 1.5s ease-in-out infinite;
}

.loading-text-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.loading-text {
  color: #4F46E5;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.2em;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
}

.dots-pulse {
  display: flex;
  gap: 4px;
}

.dots-pulse span {
  width: 4px;
  height: 4px;
  background: #6366F1;
  border-radius: 50%;
  animation: dots 1.4s infinite ease-in-out both;
}

.dots-pulse span:nth-child(1) {
  animation-delay: -0.32s;
}

.dots-pulse span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(0.8);
    opacity: 0.5;
    box-shadow: 0 0 0px #6366F1;
  }

  50% {
    transform: scale(1.2);
    opacity: 1;
    box-shadow: 0 0 20px #6366F1;
  }
}

@keyframes dots {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

/* Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
